// extracted by mini-css-extract-plugin
module.exports = {"PlusMinus":"PlusMinus_PlusMinus__O9Mlu","value":"PlusMinus_value__iN8RE"};